/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Status of the RNIC coproperty registry import.
 * @export
 * @interface CoproRegistryImportStatusDto
 */
export interface CoproRegistryImportStatusDto {
    /**
     * True while an import is in progress.
     * @type {boolean}
     * @memberof CoproRegistryImportStatusDto
     */
    importRunning?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CoproRegistryImportStatusDto
     */
    lastImportDate?: Date | null;
    /**
     * EnCours / Succes / Echec.
     * @type {string}
     * @memberof CoproRegistryImportStatusDto
     */
    lastImportStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoproRegistryImportStatusDto
     */
    lastImportError?: string | null;
    /**
     * Number of coproperties served by the active generation.
     * @type {number}
     * @memberof CoproRegistryImportStatusDto
     */
    activeRowCount?: number;
}

/**
 * Check if a given object implements the CoproRegistryImportStatusDto interface.
 */
export function instanceOfCoproRegistryImportStatusDto(value: object): value is CoproRegistryImportStatusDto {
    return true;
}

export function CoproRegistryImportStatusDtoFromJSON(json: any): CoproRegistryImportStatusDto {
    return CoproRegistryImportStatusDtoFromJSONTyped(json, false);
}

export function CoproRegistryImportStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoproRegistryImportStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'importRunning': json['importRunning'] == null ? undefined : json['importRunning'],
        'lastImportDate': json['lastImportDate'] == null ? undefined : (new Date(json['lastImportDate'])),
        'lastImportStatus': json['lastImportStatus'] == null ? undefined : json['lastImportStatus'],
        'lastImportError': json['lastImportError'] == null ? undefined : json['lastImportError'],
        'activeRowCount': json['activeRowCount'] == null ? undefined : json['activeRowCount'],
    };
}

export function CoproRegistryImportStatusDtoToJSON(json: any): CoproRegistryImportStatusDto {
    return CoproRegistryImportStatusDtoToJSONTyped(json, false);
}

export function CoproRegistryImportStatusDtoToJSONTyped(value?: CoproRegistryImportStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'importRunning': value['importRunning'],
        'lastImportDate': value['lastImportDate'] == null ? undefined : ((value['lastImportDate'] as any).toISOString()),
        'lastImportStatus': value['lastImportStatus'],
        'lastImportError': value['lastImportError'],
        'activeRowCount': value['activeRowCount'],
    };
}

